import { gql } from '@apollo/client';

interface ICollection {
  totalCount: number;
  items: Array<{
    node: {
      _id: number;
      id: string;
      name: string;
      recipes: {
        totalCount: number;
      };
      checkedRecipes: {
        edges: {
          node: {
            _id: number;
          };
        }[];
      };
    };
  }>;
}

export interface IResponse {
  collections: ICollection;
}

export interface IVariables {
  recipeId: number;
  ownedByUser: boolean;
  cursor?: string;
  itemsPerPage: number;
}

export const GET_RECIPE_COLLECTIONS = gql`
  query recipeCollections(
    $recipeId: Int!
    $ownedByUser: Boolean!
    $itemsPerPage: Int!
    $cursor: String
  ) {
    collections(
      exists: { user: $ownedByUser }
      first: $itemsPerPage
      after: $cursor
      orderBy: { name: "asc" }
    ) {
      totalCount
      items: edges {
        node {
          _id
          id
          name
          recipes {
            totalCount
          }
          checkedRecipes: recipes(id: $recipeId) {
            edges {
              node {
                _id
                title
              }
            }
          }
        }
      }
    }
  }
`;
